module.exports = (fox) => {
  "use strict";

  return {
    home: "/",
    features: "/features",
    sites: "/sites",
    faq: "/faq",
    contact: "/contact",
    iframe: "/iframe",
    registration: "/registration",
    login: "/login",
    terms: "/terms-of-use",
    privacyPolicy: "/privacy-policy",
    californiaPR: "/california-privacy-rights",
    cookiePolicy: "/cookie-policy",
    cookieTable: "/cookie-table",
    affiliateAgreement: "/affiliate-agreement",
    passrecovery: "/password-recovery",
    forgotpassword: "/forgot-password",
    complaintsPolicy: "/complaints-policy",

    globalAffilate: "https://centroprofits.com",
    mc: "https://modelcentro.com",

    twitter: "https://twitter.com/centroprofits",
    facebook: "https://www.facebook.com/centroprofits",
  };
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/utils/links.es.js